import Modal, { MODAL_TRANSITION_DURATION } from './Modal';
import { showWithTransition } from '../../utils/show';
import { wrapWithConfigDefaults } from '../../utils/helper';
export default wrapWithConfigDefaults(function (config) {
    config.onClose = config.onClose || config.onCancel;
    return showWithTransition({
        Component: Modal,
        transitionDuration: MODAL_TRANSITION_DURATION,
        autoClose: false,
        props: config,
        forcedProps: { destroyOnClose: true },
        injectClosePropNames: ['onOk', 'onCancel', 'onClose'],
        deepInjectClosePaths: ['actions.onClick'],
        contexts: config.contexts,
    });
});
